import type { InferOutput } from "valibot";

declare global { const site_options: SiteOptions; }

export const siteOptionsSchema = v.object({
  name: v.string(),
  description: v.string(),
  top_menu_items: v.array(navMenuItemSchema),
  main_menu_items: v.array(navMenuItemSchema),
  footer_menu_items: v.array(navMenuItemSchema),
  contact: v.object({
    email: v.pipe(v.string(), v.email("Le courriel est invalide.")),
    address: v.string(),
    phone: phoneSchema,
    social_medias: v.array(socialMediaSchema),
  }),
  messages: v.object({
    cart_confirmation: v.object({ title: v.string(), description: v.string() }),
    free_shipping: v.string(),
  }),
  cart_url: v.pipe(v.string(), v.url()),
  checkout_url: v.pipe(v.string(), v.url()),
  login_url: v.pipe(v.string(), v.url()),
  logout_url: v.pipe(v.string(), v.url()),
  shipping_url: v.pipe(v.string(), v.url()),
  shop_url: v.pipe(v.string(), v.url()),
  wishlist_url: v.pipe(v.string(), v.url()),
});
export type SiteOptions = InferOutput<typeof siteOptionsSchema>;
